import React, {Fragment} from 'react';
import {ChannelContentProps} from '@app/web-player/channels/channel-content';
import {TrackTable} from '@app/web-player/tracks/track-table/track-table';
import {Track} from '@app/web-player/tracks/track';
import {VirtualTableBody} from '@app/web-player/playlists/virtual-table-body';
import {ChannelHeading} from '@app/web-player/channels/channel-heading';
import {ChannelContentItem} from '@common/channels/channel';
import {useInfiniteChannelContent} from '@common/channels/requests/use-infinite-channel-content';
import clsx from 'clsx';
import {
    PaginationControls,
    PaginationControlsType,
} from '@common/ui/navigation/pagination-controls';
import {useChannelContent} from '@common/channels/requests/use-channel-content'

import { TracksFilter } from '@player/custom/TracksFilter'

export function ChannelTrackTable(
    props: ChannelContentProps<ChannelContentItem<Track>>,
) {
    const isInfiniteScroll =
        !props.isNested &&
        (!props.channel.config.paginationType ||
            props.channel.config.paginationType === 'infiniteScroll');
    return (
        <Fragment>
            <div className="flex mb-24 flex-col gap-10">
                <h4 className="mr-auto shrink-0">{props.channel.name}</h4>
                <TracksFilter type="tracks" channel={props.channel} />
            </div>

            {isInfiniteScroll ? (
                <InfiniteScrollTable {...props} />
            ) : (
                <PaginatedTable {...props} />
            )}
        </Fragment>
    );
}

function PaginatedTable({channel, isNested}: ChannelContentProps<Track>) {
    const shouldPaginate = !isNested;
    const query = useChannelContent<ChannelContentItem<Track>>(channel, { with: 'tags,activity' }, {
        isNested,
    });

    return (
        <div
            className={clsx(
                'transition-opacity',
                query.isPlaceholderData && 'opacity-70',
            )}
        >
            <TrackTable tracks={query.data?.data || []} enableSorting={false} />
            {shouldPaginate && (
                <PaginationControls
                    pagination={query.data}
                    type={channel.config.paginationType as PaginationControlsType}
                    className="mt-24"
                    scrollToTop
                />
            )}
        </div>
    );
}

function InfiniteScrollTable({channel}: ChannelContentProps<Track>) {
    const query = useInfiniteChannelContent<ChannelContentItem<Track>>(channel);

    const totalItems =
        channel.content && 'total' in channel.content
            ? channel.content.total
            : undefined;

    return (
        <TrackTable
            enableSorting={false}
            tracks={query.items}
            tableBody={<VirtualTableBody query={query} totalItems={totalItems} />}
        />
    );
}
